const Spinner = (color = null) => {
  return (
    <div className={`flex justify-center items-center min-h-screen app-bg-${color}`}>
      <div className="border-t-4 border-b-4 border-solid border-[#ffbb39] w-16 h-16 rounded-full animate-spin"></div>
    </div>
  );
};

export default Spinner;
